export const getAccessToken = (): string | null =>
  localStorage.getItem('token');
